"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ButtonCreate = /** @class */ (function (_super) {
    __extends(ButtonCreate, _super);
    function ButtonCreate(props) {
        return _super.call(this, props) || this;
    }
    ButtonCreate.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    ButtonCreate.prototype.getNoMenuRenderObject = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { icon: "file", ghost: true, type: "primary", style: { margin: "2px", marginBottom: "7px" }, onClick: this.buttonClick.bind(this) })));
    };
    ButtonCreate.prototype.getYesMenuRenderObject = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Dropdown, { overlay: this.props.menu, trigger: ['click'] },
                React.createElement(antd_1.Button, { icon: "file", ghost: true, type: "primary", style: { margin: "2px", marginBottom: "7px" } }))));
    };
    ButtonCreate.prototype.getRenderObject = function () {
        if (this.props.menu) {
            return this.getYesMenuRenderObject();
        }
        else {
            return this.getNoMenuRenderObject();
        }
    };
    ButtonCreate.prototype.render = function () {
        return this.getRenderObject();
    };
    return ButtonCreate;
}(React.Component));
exports.default = ButtonCreate;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/buttons/ButtonCreate.tsx
// module id = 1753
// module chunks = 0